export default "__VITE_ASSET__Co$0pUKX__"